import { BetaFeatureRequest, BetaFeatureResponse } from '@/Interfaces/I_betaFeature';
import { UserGroupResponse, UserResponse } from '@/Interfaces/I_userGroup';

import { customAxios } from '../index';

const BASE_URL = '/hktv_koc/cms';

// Beta Feature endpoints
export function getAllBetaFeatures() {
  return customAxios.get<BetaFeatureResponse[]>(`${BASE_URL}/beta_features`);
}

export function getBetaFeature(id: number) {
  return customAxios.get<BetaFeatureResponse>(`${BASE_URL}/beta_features/${id}`);
}

export function createBetaFeature(data: BetaFeatureRequest) {
  return customAxios.post<BetaFeatureResponse>(`${BASE_URL}/beta_features`, data);
}

export function updateBetaFeature(id: number, data: BetaFeatureRequest) {
  return customAxios.put<BetaFeatureResponse>(`${BASE_URL}/beta_features/${id}`, data);
}

export function deleteBetaFeature(id: number) {
  return customAxios.delete(`${BASE_URL}/beta_features/${id}`);
}

// Beta Feature Users endpoints
export function getBetaFeatureUsers(id: number) {
  return customAxios.get<UserResponse[]>(`${BASE_URL}/beta_features/${id}/users`);
}

export function addUserToBetaFeature(id: number, userId: number) {
  return customAxios.post(`${BASE_URL}/beta_features/${id}/users/${userId}`);
}

export function removeUserFromBetaFeature(id: number, userId: number) {
  return customAxios.delete(`${BASE_URL}/beta_features/${id}/users/${userId}`);
}

// Beta Feature User Groups endpoints
export function getBetaFeatureUserGroups(id: number) {
  return customAxios.get<UserGroupResponse[]>(`${BASE_URL}/beta_features/${id}/user-groups`);
}
